import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMetadata,
    withFragmentSearchFilter,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    RequisitionLineCreate,
    RequisitionLineDto,
    RequisitionLineRead,
    RequisitionLineSearchParams,
} from '../../entities/requisition-line.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.RequisitionLine);

withDefaultEntityMetadata<RequisitionLineDto>(symbols.dto, {
    externalReferenceId: String,
    item: Object,
    lineNumber: String,
    notes: String,
    purchaseOrder: Object,
    purchaseOrderLine: Object,
    quantity: Number,
    requestedByDate: String,
    requisition: Object,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    unitOfMeasure: String,
    customFields: [CustomFieldMetadataMap.symbols.dto],
});

withDefaultEntityMetadata<RequisitionLineRead>(symbols.entity, {
    externalReferenceId: String,
    item: Object,
    lineNumber: String,
    notes: String,
    purchaseOrder: Object,
    purchaseOrderLine: Object,
    quantity: Number,
    requestedByDate: String,
    requisition: Object,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    unitOfMeasure: String,
    customFields: [CustomFieldMetadataMap.symbols.entity],
});

withMetadata<RequisitionLineCreate>(symbols.createBody, {
    externalReferenceId: String,
    itemId: String,
    lineNumber: String,
    notes: String,
    purchaseOrderHeaderId: String,
    purchaseOrderLineId: String,
    quantity: Number,
    requestedByDate: String,
    requisitionId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    unitOfMeasure: String,
});

withDefaultSearchParamsMetadata<RequisitionLineSearchParams>(
    symbols.searchParams,
    {
        requisitionId2: String,
        requestedByDateRangeStart: String,
        requestedByDateRangeEnd: String,
        purchaseOrderLineId: String,
        status: String,
        requisitionId: String,
        lineNumber: String,
        itemId: String,
        externalReferenceId: String,
        ids: [String],
    }
);

export const RequisitionLineMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<RequisitionLineRead, RequisitionLineDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<RequisitionLineDto, RequisitionLineRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<RequisitionLineDto, RequisitionLineCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                d => d.itemId,
                mapFrom(s => s.item?.id)
            ),
            forMember(
                d => d.requisitionId,
                mapFrom(s => s.requisition?.id)
            ),
            forMember(
                d => d.purchaseOrderHeaderId,
                mapFrom(s => s.purchaseOrder?.id)
            ),
            forMember(
                d => d.purchaseOrderLineId,
                mapFrom(s => s.purchaseOrderLine?.id)
            )
        );
        createMap<
            IQueryParams<RequisitionLineDto>,
            RequisitionLineSearchParams
        >(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('status'),
            withFragmentSearchFilter('requisition'),
            withSearchFilter('lineNumber'),
            withFragmentSearchFilter('item'),
            withFragmentSearchFilter('purchaseOrderLine'),
            withSearchFilter('externalReferenceId')
            // ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
